import React from "react";
import { Modal } from "react-bootstrap";
import CommomButton from "../common-button";

const ConfirmationModal = ({ show, onHide, onConfirm, title, message }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || "Confirmation"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message || "Are you sure you want to continue?"}</p>
      </Modal.Body>
      <Modal.Footer>
         <CommomButton
          title="Cancel"
          onClick={onHide}
          className="btn-primary primary-shadow"
        />
        <CommomButton
          title="Yes, Continue"
          onClick={onConfirm}
          className="btn-primary primary-shadow"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
